var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRangeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Date_range_fill",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M2,9c0-1.886,0-2.828.586-3.414S4.114,5,6,5H18c1.886,0,2.828,0,3.414.586S22,7.114,22,9c0,.471,0,.707-.146.854S21.471,10,21,10H3c-.471,0-.707,0-.854-.146S2,9.471,2,9Z",
    fill: "#446fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M2,18c0,1.886,0,2.828.586,3.414S4.114,22,6,22H18c1.886,0,2.828,0,3.414-.586S22,19.886,22,18V13c0-.471,0-.707-.146-.854S21.471,12,21,12H3c-.471,0-.707,0-.854.146S2,12.529,2,13Zm5-3c0-.471,0-.707.146-.854S7.529,14,8,14h2c.471,0,.707,0,.854.146S11,14.529,11,15s0,.707-.146.854S10.471,16,10,16H8c-.471,0-.707,0-.854-.146S7,15.471,7,15Zm.146,3.146C7,18.293,7,18.529,7,19s0,.707.146.854S7.529,20,8,20h2c.471,0,.707,0,.854-.146S11,19.471,11,19s0-.707-.146-.854S10.471,18,10,18H8C7.529,18,7.293,18,7.146,18.146ZM13,15c0-.471,0-.707.146-.854S13.529,14,14,14h2c.471,0,.707,0,.854.146S17,14.529,17,15s0,.707-.146.854S16.471,16,16,16H14c-.471,0-.707,0-.854-.146S13,15.471,13,15Zm.146,3.146C13,18.293,13,18.529,13,19s0,.707.146.854S13.529,20,14,20h2c.471,0,.707,0,.854-.146S17,19.471,17,19s0-.707-.146-.854S16.471,18,16,18H14C13.529,18,13.293,18,13.146,18.146Z",
    fill: "#446fa2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M7,3V6",
    fill: "none",
    stroke: "#446fa2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M17,3V6",
    fill: "none",
    stroke: "#446fa2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangeFill);
export default __webpack_public_path__ + "static/media/Date_range_fill.21ebaacedd51bf86abb8b119d051d7f1.svg";
export { ForwardRef as ReactComponent };